module.exports = "<div class=\"alert alert-{{type}}\" role=\"alert\">\n  <app-wct-label\n    [inputValue]=\"message\"></app-wct-label>\n</div>"